import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('compMstStore', Object.keys(state)), // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
	...mapGetters('compMstStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('compMstStore', Object.keys(actions)),
	...mapMutations('compMstStore', Object.keys(mutations))
};
